import React, { Component } from 'react';
import { store } from '../../redux/store';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';

import './index.css';

import ThreadItem from '../../threaditem';

import SecureAxiosClient from '../../auth/secure_axios';
import getConfig from '../../config';
import * as ChatActions from '../../redux/actions/chat';

const LATEST_THREAD_DURATION_HRS = 180
class LatestThreads extends Component {

    constructor(props) {
        super(props);

        this.state = { threads: [] };
        this.recordInteraction = this.recordInteraction.bind(this);
    }

    componentDidMount() {
        this.getAllThreads();


        store.dispatch(ChatActions.setThemeImage({
            theme_image: null
        }));
    }

    recordInteraction() {
        const { user } = this.props;
        const config = getConfig();
        const url = config.bowser.domain + config.bowser.services.interaction;
        const data = { user_id: user.user_id, item_id: 'home-page' };

        axios.post(
            url,
            data
        ).then(resp => {
            console.log('interaction recorded:', resp);
            this.getAllThreads();
        }).catch(err => console.log(err));
    }

    getAllThreads() {
        let config = getConfig();
        let getThreadUrl = `${config.luigi.domain}${config.luigi.services.latest_thread}` + LATEST_THREAD_DURATION_HRS;
        console.log("Get Thread url:", getThreadUrl);
        new SecureAxiosClient().get(
            getThreadUrl,
            (responseCode, responseData) => {
                console.log("List of thread", responseData);
                if (responseCode == 200) {
                    this.setState({ threads: responseData });
                } else if (responseCode == 404) {
                    this.recordInteraction(this.state.user_id);
                }
            }
        )
    }


    render() {
        const threadLists = this.state.threads && this.state.threads
            .filter(thread => thread && !thread.disabled)
            .map(thread => (
                <ThreadItem key={thread.id} thread={thread} />
            ));
        return (
            <div className='page'>
                <h1>Latest Threads</h1>
                <div className='thread-list'>
                    <ul>
                        {threadLists}
                    </ul>
                </div>
            </div>
        );
    }
}

LatestThreads.propTypes = {
	user: PropTypes.object
}

const mapStateToProps = (state) => {
	return {
		user: state.user
	};
};


export default connect(mapStateToProps, null)(LatestThreads);

